module.exports = __webpack_public_path__ + "img/260720945_2_10.4df094ec.png";